import {
  fetchResource,
  fetchCollection,
  createResource,
  updateResource
} from './index'

import { pinSchema } from '../schemas'

import imageToDataURI from '../helpers/imageToDataURI'

export const AREA_PINS_REQUEST = 'AREA_PINS_REQUEST'
export const AREA_PINS_SUCCESS = 'AREA_PINS_SUCCESS'
export const AREA_PINS_FAILURE = 'AREA_PINS_FAILURE'

export function fetchPinsForArea (areaId) {
  return fetchCollection({
    url: `/areas/${areaId}/pins`,
    key: 'pins',
    schema: pinSchema,
    actions: [ AREA_PINS_REQUEST, AREA_PINS_SUCCESS, AREA_PINS_FAILURE ],
    responseInterceptor: response => ({ ...response, areaId })
  })
}

export const FETCH_PIN_REQUEST = 'FETCH_PIN_REQUEST'
export const FETCH_PIN_SUCCESS = 'FETCH_PIN_SUCCESS'
export const FETCH_PIN_FAILURE = 'FETCH_PIN_FAILURE'

export function fetchPin (pinId) {
  return fetchResource({
    url: `/pins/${pinId}`,
    key: 'pin',
    schema: pinSchema,
    actions: [ FETCH_PIN_REQUEST, FETCH_PIN_SUCCESS, FETCH_PIN_FAILURE ]
  })
}

export const CREATE_PIN_REQUEST = 'CREATE_PIN_REQUEST'
export const CREATE_PIN_SUCCESS = 'CREATE_PIN_SUCCESS'
export const CREATE_PIN_FAILURE = 'CREATE_PIN_FAILURE'

export function createPinForArea (areaId, data) {
  return (dispatch, getState) => (
    encodePinImages(data).then(() => dispatch(
      createResource({
        url: `/areas/${areaId}/pins`,
        key: 'pin',
        schema: pinSchema,
        actions: [ CREATE_PIN_REQUEST, CREATE_PIN_SUCCESS, CREATE_PIN_FAILURE ],
        data,
        sendAsFormData: true
      })
    ))
  )
}

export const UPDATE_PIN_REQUEST = 'UPDATE_PIN_REQUEST'
export const UPDATE_PIN_SUCCESS = 'UPDATE_PIN_SUCCESS'
export const UPDATE_PIN_FAILURE = 'UPDATE_PIN_FAILURE'

export function updatePin (pinId, data) {
  return (dispatch, getState) => (
    encodePinImages(data).then(() => dispatch(
      updateResource({
        url: `/pins/${pinId}`,
        key: 'pin',
        schema: pinSchema,
        data,
        actions: [ UPDATE_PIN_REQUEST, UPDATE_PIN_SUCCESS, UPDATE_PIN_FAILURE ]
      })
    ))
  )
}

function encodePinImages (data) {
  return imageToDataURI(data.beforeImage)
    .then((encoded) => { data.beforeImage = encoded })
    .then(() => imageToDataURI(data.afterImage))
    .then((encoded) => { data.afterImage = encoded })
}



// WEBPACK FOOTER //
// ./src/actions/pins.js